<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznisilanlari from "@/models/mznisilanlari";


export default {
  mixins: [apibtoast, apigeneric, mznisilanlari],
  props: ["Id"],
  data() {
    return {
      TableData: {},
      FormData: {},
    };
  },
  components: {
    Loader,


  },
  created() {
    this.Get();
  },
  watch: {
    Id() {
      this.TableData = this.Id;
    }
  },

  methods: {
    Get() { },

  }

};
</script>
<template>
  <Loader>
    <b-modal id="eye" size="lg" title="İlan Detay" title-class="font-18" hide-footer>
      <br>
      <div class="table-responsive mt-5">
        <table class="table mb-0 table-bordered">
          <tbody>
            <tr>
              <td style="width: 175px;">{{ $t("mznisilanlari.Eye.Yayinlanmatarihi")}} :</td>
              <td>{{ TableData.Yayinlanmatarihi | formatDateTable }}</td>
            </tr>
            <tr>
              <td style="width: 175px;">{{ $t("mznisilanlari.Eye.Firmaadi")}} :</td>
              <td>{{ TableData.Firmaadi }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Sektor")}} :</td>
              <td>{{ TableData.Sektor }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Egitimseviyesi") }} :</td>
              <td>{{ TableData.Egitimseviyesivalue}}</td>
            </tr>
       <!--    <tr>
              <td>{{ $t("mznisilanlari.Eye.Tecrube") }} :</td>
              <td>{{ TableData.Tecrube }}</td>
            </tr>  --> 
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Pozisyon")}} :</td>
              <td>{{ TableData.Pozisyon }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Departman") }} :</td>
              <td>{{ TableData.Departman }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Calismasekli") }} :</td>
              <td>{{ TableData.Calismaseklivalue }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Istipi") }} :</td>
              <td>{{ TableData.Istipivalue }}</td>
            </tr>
          <!--  <tr>
              <td>{{ $t("mznisilanlari.Eye.Cinsiyet") }} :</td>
              <td>{{ TableData.Cinsiyetvalue }}</td>
            </tr> 
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Ehliyet") }} :</td>
              <td>{{ TableData.Ehliyetvalue }}</td>
            </tr> 
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Askerlikdurumu") }} :</td>
              <td>{{ TableData.Askerlikdurumuvalue }}</td>
            </tr>   -->
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Isintanimi") }} :</td>
              <td>{{ TableData.Isintanimi }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Aciklama") }} :</td>
              <td>{{ TableData.Aciklama }}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Sonbasvurutarihi") }} :</td>
              <td>{{ TableData.Sonbasvurutarihi | formatDateTable}}</td>
            </tr>
            <tr>
              <td>{{ $t("mznisilanlari.Eye.Isilanlinki") }} :</td>
              <td v-if="TableData.Isilanlinki != null">
                <b-button type="button" class="btn btn-success col-md-3">
                  <i class="mdi mdi-text-search"></i>

                  <a :href="TableData.Isilanlinki" target="_newblank" style="color:aliceblue">
                    {{ $t("mznisilanlari.Eye.ilanlinki") }}</a>
                </b-button>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </Loader>
</template>
